import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { VentaListItem, FiltroVenta } from '../types/explorador.types';
import { initialFiltroVenta } from '../types/explorador.types';
import { ExploradorVentaService } from '../services/exploradorService';

interface ExploradorState {
  items: VentaListItem[];
  totalRegistros: number;
  totalPaginas: number;
  filtro: FiltroVenta;
  loading: boolean;
  error: string | null;

  fetchVentas: () => Promise<void>;
  setFiltro: (filtro: Partial<FiltroVenta>) => void;
  resetFiltro: () => void;
  clearError: () => void;
  reset: () => void;
}

const initialState = {
  items: [],
  totalRegistros: 0,
  totalPaginas: 0,
  filtro: initialFiltroVenta,
  loading: false,
  error: null,
};

export const useExploradorStore = create<ExploradorState>()(
  devtools(
    (set, get) => ({
      ...initialState,

      fetchVentas: async () => {
        set({ loading: true, error: null }, false, 'explorador/fetchVentas/start');
        try {
          const result = await ExploradorVentaService.getVentas(get().filtro);
          set({
            items: result.items,
            totalRegistros: result.totalRegistros,
            totalPaginas: result.totalPaginas,
            loading: false,
          }, false, 'explorador/fetchVentas/success');
        } catch (error) {
          set({
            loading: false,
            error: error instanceof Error ? error.message : 'Error al cargar ventas',
          }, false, 'explorador/fetchVentas/error');
        }
      },

      setFiltro: (filtro) => {
        set((state) => ({
          filtro: { ...state.filtro, ...filtro },
        }), false, 'explorador/setFiltro');
      },

      resetFiltro: () => {
        set({ filtro: initialFiltroVenta }, false, 'explorador/resetFiltro');
      },

      clearError: () => set({ error: null }, false, 'explorador/clearError'),
      reset: () => set(initialState, false, 'explorador/reset'),
    }),
    { name: 'explorador-ventas-store' }
  )
);
